import React from "react";
import { useNavigate } from "react-router-dom";
import "./outlet-product.scss";

const products = [
  {
    id: 1,
    name: "Chicken Rice Bowl",
    price: "RM18.90",
    dailyQuantity: "50",
    dailySold: "18",
    pickupRange: "5:00 PM - 8:00 PM",
    status: "Active",
  },
];

const hasProduct = products.length > 0;

function PageHero({ onAction }) {
  return (
    <section className="outlet-product__hero">
      <div>
        <p>SecondBite Vendor</p>
        <h2>Outlet / Product Setting</h2>
        <span>Manage outlet profile, pickup settings, products, and daily quantity.</span>
      </div>

      <button type="button" onClick={onAction}>
        {hasProduct ? "Edit Product" : "+ Add Product"}
      </button>
    </section>
  );
}

function ReadOnlyField({ label, value, note }) {
  return (
    <label className="outlet-product__field outlet-product__field--readonly">
      <span>{label}</span>
      <input value={value} readOnly aria-readonly="true" />
      {note ? <small>{note}</small> : null}
    </label>
  );
}

function EditableField({ label, children }) {
  return (
    <label className="outlet-product__field">
      <span>{label}</span>
      {children}
    </label>
  );
}

const OutletProductPage = () => {
  const navigate = useNavigate();

  const handleProductAction = () => {
    navigate(hasProduct ? "/vendor/products/1/edit" : "/vendor/products/create");
  };

  return (
    <div className="outlet-product">
      <PageHero onAction={handleProductAction} />

      <section className="outlet-product__card">
        <div className="outlet-product__card-header">
          <div>
            <h3>Outlet Setup</h3>
            <p>Vendor can only update operational outlet details. Business and bank information are managed by admin.</p>
          </div>
        </div>

        <div className="outlet-product__section">
          <div className="outlet-product__section-title">
            <h4>Outlet Information</h4>
          </div>

          <div className="outlet-product__form-grid outlet-product__form-grid--three">
            <ReadOnlyField label="Outlet Name" value="Hikari House" note="Managed by admin." />

            <EditableField label="Phone">
              <input defaultValue="012-3456789" />
            </EditableField>

            <EditableField label="Accepting Orders">
              <select defaultValue="Yes">
                <option>Yes</option>
                <option>No</option>
              </select>
            </EditableField>

            <EditableField label="Address">
              <input defaultValue="Level 2, City Mall, Kuching" />
            </EditableField>

            <EditableField label="Google Maps URL">
              <input defaultValue="https://maps.google.com/..." />
            </EditableField>

            <EditableField label="Pickup Window">
              <input defaultValue="5:00 PM - 8:00 PM" />
            </EditableField>
          </div>
        </div>

        <div className="outlet-product__section">
          <div className="outlet-product__section-title">
            <h4>Bank Information</h4>
            <p>Managed by platform admin.</p>
          </div>

          <div className="outlet-product__form-grid outlet-product__form-grid--three">
            <ReadOnlyField label="Bank Name" value="Maybank" />
            <ReadOnlyField label="Receiver Name" value="Hikari House Sdn Bhd" />
            <ReadOnlyField label="Account Number" value="512345678901" />
          </div>
        </div>
      </section>

      <section className="outlet-product__card">
        <div className="outlet-product__card-header">
          <div>
            <h3>Products Listing</h3>
            <p>For MVP, each outlet manages one product. Add product is only available when no product exists.</p>
          </div>
        </div>

        <div className="outlet-product__table outlet-product__table--products">
          <div className="outlet-product__table-head">
            <span>Product</span>
            <span>Price</span>
            <span>Daily Quantity</span>
            <span>Daily Sold</span>
            <span>Pickup Range</span>
            <span>Status</span>
            <span>Actions</span>
          </div>

          {products.map((product) => (
            <div className="outlet-product__table-row" key={product.id}>
              <span>{product.name}</span>
              <span>{product.price}</span>
              <span>{product.dailyQuantity}</span>
              <span>{product.dailySold}</span>
              <span>{product.pickupRange}</span>
              <span className="status-pill status-pill--active">{product.status}</span>
              <button type="button" onClick={() => navigate(`/vendor/products/${product.id}/edit`)}>
                Edit
              </button>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default OutletProductPage;
